module.exports = [{
      plugin: require('../node_modules/@qite/gatsby-source-tide/gatsby-browser.js'),
      options: {"plugins":[],"host":"https://tide-voetbalreizen7952.tidesoftware.be","apiKey":"IbHvQxUw6yJONvk3F5U6ZIKeuxmuvnbryZtYCSrhqPj148KT8vzNVXhM2QOjBQGh","channelId":3,"isPreview":false,"ignoreSslErrors":true,"useImageFiles":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Voetbalreizen","short_name":"Voetbalreizen","start_url":"/","background_color":"#EF8121","theme_color":"#EF8121","display":"minimal-ui","icon":"src/images/voetbalreizen/voetbalreizen-icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"8221bcb90d4384b23f99dfc523e1e3da"},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.voetbalreizen.com/","stripQueryString":true},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
